<script>
import {getDownloadURL} from '../../helper/ImageCache'; 

let gsReference = null;
let filePath = '';
let className = '';
let uid;
export {filePath as src};
export {className as class};

export {uid as id};
export let isExternal = false;
export let mode = 0;

let style;

switch(mode){
    case 0: /*Default*/; break;
    case 1: style=`max-height:200px; width: auto; margin:0 auto` ; break;
}

function onChange(){
    if(filePath == gsReference)
        return;
    if(isExternal){
        gsReference = filePath;
    }
    else{
        getDownloadURL(filePath).then((url)=>{
            gsReference = url;
        })
    }
}

$: filePath && onChange();



</script>
<img crossorigin="anonymous" src="{gsReference}" alt="test" class="{className}" class:invisible={gsReference == null} id={uid} style={style} />